import { useMemo } from 'react';

import { CreateUserType } from '@xemplo/gp-types';
import { RadioGroupV2, RadioOption } from '@xemplo/radio-button';
import { TextFieldRhf } from '@xemplo/text-field';
import { useGetRoles } from '@xemplo/users-query';

import * as S from './create-company-user-form.styles';

export function AssignRoleSection() {
  const { data: roles } = useGetRoles(CreateUserType.CompanyUser);

  const roleOptions: RadioOption[] = useMemo(
    () =>
      (roles ?? [])
        .filter((role) => role.key !== '-1')
        .map((role) => ({ label: role.value, value: role.key })),
    [roles],
  );

  return (
    <S.Fieldset>
      <S.Legend>
        Assign role
        <S.Subtitle>
          Assigning a role to a user will grant access to specific system features.
        </S.Subtitle>
      </S.Legend>
      {/* Hidden field keeps companyId (set via defaultValues) registered in RHF */}
      <TextFieldRhf aria-label="company id" name="userPersona.0.companyId" hidden />
      <S.RadioGroupWrapper>
        <RadioGroupV2
          ariaLabel="Assign role options"
          name="userPersona.0.roleId"
          options={roleOptions}
          rules={{ required: 'Please assign a role' }}
          showLabel
        />
      </S.RadioGroupWrapper>
    </S.Fieldset>
  );
}
